import React, { useEffect, useRef } from 'react';

const Testimonials = () => {
  const scrollRef = useRef(null);

  const testimonials = [
    {
      name: 'Marc D.',
      location: 'Paris',
      rating: 5,
      date: 'Il y a 2 jours',
      verified: true,
      text: 'Service exceptionnel ! Mon jardin n\'a jamais été aussi beau. L\'équipe est professionnelle et à l\'écoute.',
      service: 'Entretien régulier'
    },
    {
      name: 'Julie R.',
      location: 'Paris',
      rating: 4.5,
      date: 'Il y a 5 jours',
      verified: true,
      text: 'Très satisfaite de la taille de mes haies. Travail soigné et rapide. Je recommande vivement.',
      service: 'Taille de haie'
    },
    {
      name: 'Thomas B.',
      location: 'Boulogne-Billancourt',
      rating: 5,
      date: 'Il y a 1 semaine',
      verified: true,
      text: 'Élagage parfaitement réalisé. L\'équipe a su préserver mes arbres tout en les rendant plus sains.',
      service: 'Élagage d\'arbres'
    },
    {
      name: 'Sarah M.',
      location: 'Nanterre',
      rating: 5,
      date: 'Il y a 3 jours',
      verified: true,
      text: 'Nettoyage de terrasse impeccable. Ma terrasse est comme neuve, je suis ravie du résultat.',
      service: 'Nettoyage de terrasse'
    },
    {
      name: 'Kevin L.',
      location: 'Créteil',
      rating: 4,
      date: 'Il y a 4 jours',
      verified: true,
      text: 'Tonte régulière bien effectuée. Mon gazon est toujours impeccable, merci pour le suivi.',
      service: 'Tonte de pelouse'
    },
    {
      name: 'Emma P.',
      location: 'Versailles',
      rating: 5,
      date: 'Il y a 6 jours',
      verified: true,
      text: 'Service entreprise au top. L\'entretien de nos espaces verts est maintenant parfaitement géré.',
      service: 'Service entreprises'
    },
    {
      name: 'Antoine G.',
      location: 'Courbevoie',
      rating: 5,
      date: 'Il y a 2 jours',
      verified: true,
      text: 'Meilleur paysagiste que j\'ai eu. Travail soigné, équipe ponctuelle et professionnelle.',
      service: 'Entretien complet'
    },
    {
      name: 'Laura K.',
      location: 'Montreuil',
      rating: 4.5,
      date: 'Il y a 1 semaine',
      verified: true,
      text: 'Très bon service. Les conseils pour l\'entretien de mon jardin ont été précieux.',
      service: 'Conseil et entretien'
    },
    {
      name: 'Maxime V.',
      location: 'Saint-Denis',
      rating: 5,
      date: 'Il y a 3 jours',
      verified: true,
      text: 'Intervention rapide et efficace. Mon jardin est maintenant magnifique toute l\'année.',
      service: 'Entretien régulier'
    },
    {
      name: 'Camille D.',
      location: 'Argenteuil',
      rating: 5,
      date: 'Il y a 5 jours',
      verified: true,
      text: 'Service particulier parfait. L\'équipe s\'adapte à mes besoins et fait un travail remarquable.',
      service: 'Service particulier'
    },
    {
      name: 'Lucas M.',
      location: 'Paris',
      rating: 5,
      date: 'Il y a 1 jour',
      verified: true,
      text: 'Travail de qualité exceptionnelle. Mon jardin est devenu un véritable havre de paix.',
      service: 'Aménagement paysager'
    },
    {
      name: 'Clara S.',
      location: 'Vitry-sur-Seine',
      rating: 4,
      date: 'Il y a 3 jours',
      verified: true,
      text: 'Bon service, équipe sympathique. Le nettoyage de ma terrasse est parfait.',
      service: 'Nettoyage de terrasse'
    },
    {
      name: 'Hugo F.',
      location: 'Asnières-sur-Seine',
      rating: 5,
      date: 'Il y a 2 jours',
      verified: true,
      text: 'Exactement ce qu\'il me fallait. Service professionnel et résultats au-delà de mes attentes.',
      service: 'Taille de haie'
    },
    {
      name: 'Léa B.',
      location: 'Colombes',
      rating: 5,
      date: 'Il y a 4 jours',
      verified: true,
      text: 'Super service. Gain de temps énorme et jardin toujours impeccable.',
      service: 'Entretien régulier'
    },
    {
      name: 'Nathan P.',
      location: 'Aulnay-sous-Bois',
      rating: 4.5,
      date: 'Il y a 1 semaine',
      verified: true,
      text: 'Bonne qualité de service. L\'équipe est réactive et fait un travail soigné.',
      service: 'Élagage d\'arbres'
    },
    {
      name: 'Chloé L.',
      location: 'Rueil-Malmaison',
      rating: 5,
      date: 'Il y a 3 jours',
      verified: true,
      text: 'Parfait pour l\'entretien de mon jardin. Très satisfaite de leur intervention.',
      service: 'Service particulier'
    },
    {
      name: 'Alexandre T.',
      location: 'Champigny-sur-Marne',
      rating: 5,
      date: 'Il y a 2 jours',
      verified: true,
      text: 'Excellent service. Mon jardin n\'a jamais été aussi bien entretenu.',
      service: 'Entretien complet'
    },
    {
      name: 'Manon R.',
      location: 'Aubervilliers',
      rating: 4,
      date: 'Il y a 5 jours',
      verified: true,
      text: 'Bien fait. L\'équipe est professionnelle et le résultat est à la hauteur.',
      service: 'Tonte de pelouse'
    }
  ];

  // Doubler les avis pour un défilement infini
  const duplicatedTestimonials = [...testimonials, ...testimonials];

  useEffect(() => {
    const scrollContainer = scrollRef.current;
    if (!scrollContainer) return;

    let animationFrameId;
    let scrollPosition = 0;
    const scrollSpeed = 0.5; // Vitesse du défilement

    const scroll = () => {
      scrollPosition += scrollSpeed;
      
      // Réinitialiser la position quand on a défilé la moitié (une fois les avis originaux)
      if (scrollPosition >= scrollContainer.scrollWidth / 2) {
        scrollPosition = 0;
      }
      
      scrollContainer.scrollLeft = scrollPosition;
      animationFrameId = requestAnimationFrame(scroll);
    };

    animationFrameId = requestAnimationFrame(scroll);

    return () => {
      if (animationFrameId) {
        cancelAnimationFrame(animationFrameId);
      }
    };
  }, []);

  const renderStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;

    for (let i = 0; i < fullStars; i++) {
      stars.push(
        <span key={i} style={{ color: 'var(--color-primary)', fontSize: '0.75rem' }}>★</span>
      );
    }

    if (hasHalfStar) {
      stars.push(
        <span key="half" style={{ color: 'var(--color-primary)', fontSize: '0.75rem', opacity: 0.7 }}>★</span>
      );
    }

    for (let i = stars.length; i < 5; i++) {
      stars.push(
        <span key={i} style={{ color: '#d1d5db', fontSize: '0.75rem' }}>★</span>
      );
    }

    return stars;
  };

  // Calcul de la note moyenne
  const averageRating = (testimonials.reduce((acc, t) => acc + t.rating, 0) / testimonials.length).toFixed(1);
  const totalReviews = testimonials.length;

  return (
    <section id="testimonials" style={{
      padding: '3rem 1rem',
      overflow: 'hidden',
      background: 'var(--color-beige-light)'
    }}>
      <div className="section-container" style={{ maxWidth: '1200px', margin: '0 auto', marginBottom: '3rem', padding: '0 1rem' }}>
        <div className="text-center">
          <div className="section-badge" style={{ marginBottom: '1rem' }}>Pour un jardin plus vert</div>
          <h2 className="section-title" style={{ marginBottom: '1rem', fontSize: 'clamp(1.75rem, 4vw, 3rem)' }}>
            Avis Clients
          </h2>
          <p className="section-description" style={{ fontSize: 'clamp(1rem, 2vw, 1.125rem)', color: 'var(--color-gray)', marginBottom: '2rem' }}>
            Retours d'expérience authentiques
          </p>

          {/* Score global */}
          <div style={{
            display: 'inline-flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '1rem',
            background: 'linear-gradient(to right, rgba(22, 163, 74, 0.1), rgba(22, 163, 74, 0.15))',
            padding: '1rem 1.5rem',
            borderRadius: '1rem',
            border: '1px solid rgba(22, 163, 74, 0.2)',
            width: '100%',
            maxWidth: '400px'
          }}
          className="testimonial-rating-box">
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: 'clamp(2rem, 5vw, 2.5rem)', fontWeight: 'bold', color: 'var(--color-primary)' }}>{averageRating}</div>
              <div style={{ fontSize: '0.875rem', color: 'var(--color-gray)' }}>sur 5</div>
            </div>
            <div style={{ borderTop: '1px solid rgba(22, 163, 74, 0.3)', borderLeft: 'none', paddingTop: '1rem', paddingLeft: 0, width: '100%', textAlign: 'center' }}>
              <div style={{ display: 'flex', gap: '0.25rem', marginBottom: '0.5rem', justifyContent: 'center' }}>
                {renderStars(parseFloat(averageRating))}
              </div>
              <div style={{ fontSize: '0.875rem', color: 'var(--color-gray)' }}>
                {totalReviews} avis vérifiés
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Carrousel défilant */}
      <div 
        ref={scrollRef}
        style={{ 
          display: 'flex',
          gap: '1rem',
          overflowX: 'hidden',
          scrollBehavior: 'auto',
          WebkitOverflowScrolling: 'touch',
          padding: '0 1rem'
        }}
      >
        {duplicatedTestimonials.map((testimonial, index) => (
          <div
            key={index}
            className="modern-card testimonial-card"
            style={{
              flexShrink: 0,
              width: '280px',
              minWidth: '280px',
              background: 'var(--color-white)',
              borderRadius: '12px',
              padding: '1.5rem',
              border: '1px solid rgba(0,0,0,0.1)',
              boxShadow: 'var(--shadow-sm)',
              transition: 'box-shadow 0.3s ease, transform 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.boxShadow = 'var(--shadow-md)';
              e.currentTarget.style.transform = 'translateY(-5px)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.boxShadow = 'var(--shadow-sm)';
              e.currentTarget.style.transform = 'translateY(0)';
            }}
          >
            {/* Header */}
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <h4 style={{ fontWeight: 'bold', color: 'var(--color-dark)', fontSize: '0.875rem' }}>{testimonial.name}</h4>
                {testimonial.verified && (
                  <span style={{ color: 'var(--color-primary)', fontSize: '0.75rem' }} title="Avis vérifié">✓</span>
                )}
              </div>
              <span style={{ fontSize: '0.75rem', color: '#9ca3af' }}>{testimonial.date}</span>
            </div>
            <p style={{ fontSize: '0.75rem', color: 'var(--color-gray)', marginBottom: '0.75rem' }}>{testimonial.location}</p>

            {/* Étoiles */}
            <div style={{ display: 'flex', gap: '0.25rem', marginBottom: '0.75rem' }}>
              {renderStars(testimonial.rating)}
            </div>

            {/* Texte */}
            <p style={{ color: 'var(--color-dark)', fontSize: '0.875rem', lineHeight: '1.6', marginBottom: '0.75rem' }}>
              {testimonial.text}
            </p>

            {/* Service */}
            <div style={{ paddingTop: '0.75rem', borderTop: '1px solid rgba(0,0,0,0.05)' }}>
              <span style={{ fontSize: '0.75rem', fontWeight: '600', color: 'var(--color-primary)' }}>
                {testimonial.service}
              </span>
            </div>
          </div>
        ))}
      </div>

      {/* Badge de confiance */}
      <div style={{ marginTop: '2.5rem', textAlign: 'center' }}>
        <div style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '0.5rem',
          background: 'rgba(22, 163, 74, 0.1)',
          border: '1px solid rgba(22, 163, 74, 0.2)',
          padding: '0.75rem 1.5rem',
          borderRadius: '2rem'
        }}>
          <span style={{ color: 'var(--color-primary)', fontSize: '1rem' }}>✓</span>
          <span style={{ color: 'var(--color-primary)', fontWeight: '600', fontSize: '0.875rem' }}>
            Avis vérifiés et authentiques
          </span>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;

